import React from 'react';
import ReactDOM from 'react-dom';
import './init';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import RootStore from './stores';

import App from './App';

import * as serviceWorker from './serviceWorker';
import './index.scss';

// use strict mode for mobx
configure({
  enforceActions: 'observed'
});

const store = new RootStore();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
